<h1 *header="'Account Login'; d9: '#block-pac-theme-pagetitle h1.title'; let title" class="page-header">{{ title }}</h1>
<form (ngSubmit)="OnSubmit()" [formGroup]="form">
  <fieldset bsMigration [bs3Class]="['panel-default']" class="panel" [disabled]="isSaving">
    <legend bsMigration class="panel-heading">Account Login</legend>
    <div bsMigration class="panel-body">
      <div class="alert alert-danger" *ngIf="(Pass.invalid || Email.invalid) && (Pass.dirty || Pass.touched)">
          <ul>
            <li *ngIf="Email.errors && Email.errors['required']">Email address is required.</li>
            <li *ngIf="Pass.errors && Pass.errors['required']">Password is required.</li>
            <li *ngIf="Email.errors && Email.errors['email']">The email address is invalid.</li>
            <ng-container *ngIf="Pass.errors['error']">
              <li *ngFor="let error of Pass.errors['error']" [innerHTML]="error"></li>
            </ng-container>
            <ng-container *ngIf="Pass.errors['warning']">
              <li *ngFor="let warning of Pass.errors['warning']" [innerHTML]="warning"></li>
            </ng-container>
          </ul>
      </div>
      <div [bs4Class]="['mb-2']" class="form-group" [class.has-error]="EmailHasError | async">
        <label for="input-email">Email Address</label>
        <input type="email" [class.is-invalid]="EmailHasError | async" class="form-control" id="input-email" name="email" required placeholder="email address" appEmailValidate formControlName="Email" #email>
        <p [bs4Class]="['my-0']" class="help-text">Enter your {{ settings.site_name }} username.</p>
      </div>
      <div [bs4Class]="['mb-2']" class="form-group" [class.has-error]="PassHasError | async">
        <label for="input-pass">Password</label>
        <input type="password" [class.is-invalid]="PassHasError | async" class="form-control" id="input-pass" name="pass" required placeholder="password" formControlName="Pass" #pass>
        <p [bs4Class]="['my-0']" class="help-text">Enter the password that accompanies your username.</p>
      </div>
      <p [bs4Class]="['mb-2']"><a href="/user/password">Forgot your password?</a></p>
      <p [bs4Class]="['mb-2']"><a href="/troubleshooting-login-problems" [appColorbox]="{ width: 800, heigh: 600 }">Trouble logging in?</a></p>
      <button type="submit" class="btn btn-primary btn-lg" [disabled]="!form.valid">Log In</button>
    </div>
  </fieldset>
</form>
